import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {RefillDTO} from '../../../models/RefillDTO';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {KeycloakService} from 'keycloak-angular';
import {RefillService} from '../../../services/refill.service';
import {LookupService} from '../../../../common/services/lookup.service';
import {HelpService} from '../../../../other/services/help.service';
import {NameValueDTO} from '../../../../common/models/NameValueDTO';
import {HelpDTO} from '../../../../other/models/HelpDTO';
import {SharedService} from '../../../../common/services/shared-service';
import {LookupValue} from '../../../../clm/types/lookup-value.enum';

@Component({
  selector: 'app-add-refill-dialog',
  templateUrl: './add-refill-dialog.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss']
})
export class AddRefillDialogComponent implements OnInit {
  readonly lookupValue = LookupValue;

  nameFormControl: FormControl;
  measureFormControl: FormControl;
  valueFormControl: FormControl;
  refillFormGroup: FormGroup;

  helpInfo: HelpDTO[];
  refillMeasures: NameValueDTO[];
  editRefill = new RefillDTO();
  isEdit = false;
  userFirstLastName = '';
  errorMessage = '';

  constructor(
    public dialogRef: MatDialogRef<AddRefillDialogComponent>,
    private formBuilder: FormBuilder,
    private refillService: RefillService,
    private keycloakService: KeycloakService,
    private lookupService: LookupService,
    private helpService: HelpService,
    private sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public id: number
  ) {
    this.nameFormControl = new FormControl('');
    this.measureFormControl = new FormControl('');
    this.valueFormControl = new FormControl('');

    this.refillFormGroup = this.formBuilder.group({
      refillName: this.nameFormControl,
      refillMeasure: this.measureFormControl,
      refillValue: this.valueFormControl
    });

    if (id != null) {
      this.isEdit = true;
      this.getRefill(id);
    }
  }

  ngOnInit(): void {
    this.getListOfLookupValues(this.lookupValue.RefillMeasure);
    this.getHelpInfo('refill');

    this.keycloakService.loadUserProfile().then(profile => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });
  }

  getRefill(id: number) {
    this.refillService.getRefill(id).subscribe(
      response => {
        this.editRefill = response;
        this.nameFormControl.setValue(this.editRefill.name);
        this.measureFormControl.setValue(this.editRefill.refillMeasurement.name);
        this.valueFormControl.setValue(this.editRefill.refillValue);
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openSnackBar(error.businessMessage, 'Dismiss');
      }
    );
  }

  getListOfLookupValues(entity: string): void {
    this.lookupService.getListOfLookupValues(entity).subscribe(
      (response: NameValueDTO[]) => {
        if (entity === this.lookupValue.RefillMeasure) {
          this.refillMeasures = response;
        }
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openSnackBar(error.businessMessage, 'Dismiss');
      }
    );
  }

  getHelpInfo(componentName: string) {
    this.helpService.getListOfHelpInfo(componentName).subscribe(
      (response) => {
        this.helpInfo = response;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openSnackBar(error.businessMessage, 'Dismiss');
      }
    );
  }

  getInfoTooltip(inputName: string): string {
    let message = '';
    if (this.helpInfo != null) {
      const helpInfo = this.helpInfo.find((help) => help.inputName === inputName);
      message = helpInfo != null ? helpInfo.inputInfo : '';
    }
    return message;
  }

  onSaveClick(): void {
    if (this.refillFormGroup.valid) {
      const refillDTO = new RefillDTO();
      refillDTO.name = this.nameFormControl.value;
      refillDTO.refillMeasurement = this.refillMeasures.find(
        (item) => item.name === this.measureFormControl.value
      );
      refillDTO.refillValue = this.valueFormControl.value;

      if (this.isEdit) {
        refillDTO.refillId = this.editRefill.refillId;
        refillDTO.created = this.editRefill.created;
        refillDTO.createdBy = this.editRefill.createdBy;
        refillDTO.updated = new Date();
        refillDTO.updatedBy = this.userFirstLastName;
      }
      else {
        refillDTO.created = new Date();
        refillDTO.createdBy = this.userFirstLastName;
      }

      this.refillService.saveRefill(refillDTO).subscribe(
        response => {
          this.sharedService.openSnackBar(`Refill ${response.name} saved successfully`, 'Dismiss');
          this.dialogRef.close();
        },
        errorResponse => {
          const error = errorResponse.error;
          this.errorMessage = error.businessMessage;
        }
      );
    }
    else {
      this.errorMessage = 'Please complete all required fields.';
    }
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
